import { render, staticRenderFns } from "./ChannelProdReg.vue?vue&type=template&id=a6488b1c&scoped=true"
import script from "./ChannelProdReg.vue?vue&type=script&lang=js"
export * from "./ChannelProdReg.vue?vue&type=script&lang=js"
import style0 from "./ChannelProdReg.vue?vue&type=style&index=0&id=a6488b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6488b1c",
  null
  
)

export default component.exports